import React, { ElementType, ReactElement } from 'react'
import { Flex, Text } from 'theme-ui'
import { Button, Svg } from 'ui'
import VerticalDivider from 'ui/VerticalDivider'
import G2Icon from 'images/organization/features/socialRatings/g2-icon.svg'
import SourceForgeIcon from 'images/organization/features/socialRatings/sourceforge-icon.svg'
import StarGreenIcon from 'images/organization/features/socialRatings/star-green.svg'
import StarBlueIcon from 'images/organization/features/socialRatings/star-blue.svg'

export default function SocialRatings(): ReactElement {
  return (
    <Flex
      sx={{
        flexShrink: 0,
        alignItems: 'center',
        justifyContent: ['center', 'flex-start'],
        gap: ['0.8rem', '1.6rem', '3.2rem'],
        '@media (max-width: 360px)': {
          gap: 0,
        },
      }}
    >
      <SocialStars
        icon={SourceForgeIcon}
        value="4.5/5"
        url="https://sourceforge.net/software/product/ControlD/"
      />
      <VerticalDivider
        sx={{
          width: '1px',
          height: '4rem',
          backgroundColor: 'cyan10',
          flexShrink: 0,
        }}
      />
      <SocialStars icon={G2Icon} value="4/5" url="https://www.g2.com/products/controld/reviews" />
      <VerticalDivider sx={{ height: '4rem', backgroundColor: 'cyan10', flexShrink: 0 }} />
      <SocialStars
        icon={StarGreenIcon}
        value="4.5/5"
        url="https://ca.trustpilot.com/review/controld.com"
      />
    </Flex>
  )
}

function SocialStars({
  icon,
  value,
  url,
}: {
  icon: ElementType
  value: string
  url: string
}): ReactElement {
  return (
    <Button
      data-testid={`${url}`}
      sx={{ flexShrink: 0, p: 0 }}
      ariaLabel={`open ${url}`}
      variant="transparent"
      onClick={() => {
        window.open(url, '_blank', 'noopener, noreferrer')
      }}
    >
      <Svg
        svg={icon}
        sx={{ width: ['3.2rem', '4rem'], height: ['3.2rem', '4rem'] }}
        descriptiveText={`${url.split('/')[2]} rating platform`}
      />
      <Text
        variant="size16Weight500Line138Letter032"
        sx={{ mr: ['0.4rem', '0.8rem'], color: 'wildBlueYonder' }}
      >
        {value}
      </Text>
      <Svg svg={StarBlueIcon} descriptiveText={`${value} star rating`} />
    </Button>
  )
}
